function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export function assign(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
}
export function chunk(iterable, length) {
  var results = [];
  var lengthOfIterable = iterable.length;

  for (var i = 0; i < lengthOfIterable; i += length) {
    var chunked = [];

    for (var ci = i; ci < i + length; ci++) {
      chunked.push(iterable[ci]);
    }

    results.push(chunked);
  }

  return results;
}
export function endsWith(string, expectedEnding) {
  if (string.length < expectedEnding.length) {
    return false;
  }

  var actualEnding = string.substr(string.length - expectedEnding.length);
  return actualEnding === expectedEnding;
}
export function forEach(iterable, func) {
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    func(iterable[i], i);
  }
}
export function invert(oldObj) {
  var newObj = {};

  for (var key in oldObj) {
    if (oldObj.hasOwnProperty(key)) {
      var value = oldObj[key];
      newObj[value] = key;
    }
  }

  return newObj;
}
export function range(n) {
  var results = [];

  for (var i = 0; i < n; i++) {
    results.push(i);
  }

  return results;
}
export function times(numTimes, func) {
  var results = [];

  for (var i = 0; i < numTimes; i++) {
    results.push(func(i));
  }

  return results;
}
export function toArray(iterable) {
  var results = [];
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    results.push(iterable[i]);
  }

  return results;
}
export function toArrayRecursively(input) {
  if (input.length) {
    return toArray(input).map(toArrayRecursively);
  }

  return input;
} // copied from https://github.com/academia-de-codigo/parse-content-range-header/blob/master/index.js

export function parseContentRange(headerValue) {
  if (!headerValue) {
    return null;
  }

  if (typeof headerValue !== 'string') {
    throw new Error('invalid argument');
  }

  var parseInt = function parseInt(number) {
    return Number.parseInt(number, 10);
  }; // Check for presence of unit


  var matches = headerValue.match(/^(\w*) /);
  var unit = matches && matches[1]; // check for start-end/size header format

  matches = headerValue.match(/(\d+)-(\d+)\/(\d+|\*)/);

  if (matches) {
    return {
      unit: unit,
      first: parseInt(matches[1]),
      last: parseInt(matches[2]),
      length: matches[3] === '*' ? null : parseInt(matches[3])
    };
  } // check for size header format


  matches = headerValue.match(/(\d+|\*)/);

  if (matches) {
    return {
      unit: unit,
      first: null,
      last: null,
      length: matches[1] === '*' ? null : parseInt(matches[1])
    };
  }

  return null;
}
/*
 * Promisified wrapper around 'setTimeout' to allow 'await'
 */

export function wait(_x) {
  return _wait.apply(this, arguments);
}

function _wait() {
  _wait = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(milliseconds) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, milliseconds);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _wait.apply(this, arguments);
}

export function zip(a, b) {
  var A = Array.isArray(a) ? a : Array.from(a);
  var B = Array.isArray(b) ? b : Array.from(b);
  return A.map(function (k, i) {
    return [k, B[i]];
  });
} // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error

export var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);

  var _super = _createSuper(AbortError);

  function AbortError(params) {
    var _this;

    _classCallCheck(this, AbortError);

    // Pass remaining arguments (including vendor specific ones) to parent constructor
    _this = _super.call(this, params); // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), AbortError);
    }

    _this.name = 'AbortError';
    return _this;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var CustomAggregateError = /*#__PURE__*/function (_Error2) {
  _inherits(CustomAggregateError, _Error2);

  var _super2 = _createSuper(CustomAggregateError);

  function CustomAggregateError(errors, message) {
    var _this2;

    _classCallCheck(this, CustomAggregateError);

    _this2 = _super2.call(this, message);
    _this2.errors = errors;
    _this2.message = message;
    _this2.name = 'AggregateError';
    return _this2;
  }

  return CustomAggregateError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var AggregateError = CustomAggregateError;